import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=f67a33da&scoped=true"
import script from "./customTable.vue?vue&type=script&lang=js"
export * from "./customTable.vue?vue&type=script&lang=js"
import style0 from "./customTable.vue?vue&type=style&index=0&id=f67a33da&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67a33da",
  null
  
)

export default component.exports